import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

interface IProps {
    name: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    name: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", { id: __props.name }, [
      _renderSlot(_ctx.$slots, "trigger")
    ], 8, _hoisted_1),
    _createVNode(_component_b_popover, {
      target: __props.name,
      triggers: "hover",
      placement: "auto",
      "custom-class": "popover-container"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["target"])
  ], 64))
}
}

})